/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, May 2020
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import { Popover, OverlayTrigger, Col, strong, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/lib/Button';
import { isMobileView, isTabletView } from '../../components/utils/utils'

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const emptyErrorDict = {
  errorText: null,
  errorTitle: null,
  showError: false,
};

const maxAttachmentsSize = 70.00

class AttachmentsPanel extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    attachments: [],
    total_size: 0.00.toFixed(2),
    fileFormats: [],
    maxAttachSize: 0.00,
    isMounted: false,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    let fileFormats = ['docx', 'pdf', 'jpg', 'zip'];
    if (this.props.formats) {
      fileFormats = this.props.formats;
    }
    const maxAttachSize = this.props.maxSizeMB || maxAttachmentsSize;
    this.setState({ colors, sourceStyle, style, fileFormats, maxAttachSize, isMounted: true });
  }

  addAttachment = () => {
    this.setState({
      attachments: [...this.state.attachments, {
        name: '',
        extension: '',
        data: '',
        size: 0.00,
      }],
    }, () => this.calculateTotalSize(this.state.attachments, emptyErrorDict));
  }

  removeAttachment = (i, errorMessDict=null) => {
    const attachments = [...this.state.attachments];
    let errorMessageDict = emptyErrorDict;

    if (i > -1) {
      attachments.splice(i, 1);
    }

    if (errorMessDict) { errorMessageDict = errorMessDict; }
    this.setState({
      attachments,
    }, () => this.calculateTotalSize(attachments, errorMessageDict));
  }

  onAttachmentChange = async (e, idx) => {
    const file = e.target.files[0];
    const name = file.name;
    const extension = name.split('.').slice(-1)[0];
    const attachments = [...this.state.attachments];
    // convert bytes to MB
    const size = file.size / 1000000;
    let sizeError = false;
    const sizeErrorDict = {
      errorText: `Maksymalny łączny rozmiar załączników to ${this.state.maxAttachSize}MB!`,
      errorTitle: 'Maksymalny rozmiar załączników przekroczony.',
      showError: true,
    };
    const formats = this.state.fileFormats.join(', ');
    const errorDict = {
      errorText: `Załącznik musi być w formacie ${formats}.`,
      errorTitle: 'Błędny format pliku.',
      showError: true,
    };
    if ((size + parseFloat(this.state.total_size)) > this.state.maxAttachSize) { sizeError = true; }
    if (!sizeError && this.state.fileFormats.includes(extension)) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = event => {
        const data = event.target.result;
        attachments[idx] = { name, extension, data, size };
        this.setState({ attachments }, () => this.calculateTotalSize(attachments, emptyErrorDict));
      };
    } else if (sizeError) {
      this.removeAttachment(idx, sizeErrorDict);
    } else { this.removeAttachment(idx, errorDict); }
  }

  calculateTotalSize = (attachments, errorDict) => {
    let totalSize = 0.00;
    for (const attachment of this.state.attachments) {
      totalSize += attachment.size;
    }
    this.setState({ total_size: totalSize.toFixed(2) }, () => this.props.onChangeAttachments(attachments, errorDict));
  }

  renderStandardRow = () => {
    return (
      this.state.attachments.map((attachment, i) =>
        <Row key={i}>
          <Col xs={7} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px' }}>
            <input type="file" style={{ color: 'red', width: '100%' }} accept=".pdf,.docx,.jpg,.zip" onChange={(e) => this.onAttachmentChange(e, i)} />
          </Col>
          <Col xs={3} style={{ paddingTop: '5px', paddingBottom: '5px', float: 'right' }}>
            <Button
              className="btn btn-danger"
              onClick={() => this.removeAttachment(i)}
            >
              Usuń
            </Button>
          </Col>
        </Row>,
      )
    )
  }

  renderMobileRow = () => {
    return (
      this.state.attachments.map((attachment, i) =>

        <Row key={i}>
        <Col xs={7} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px' }}>
          <input type="file" style={{ color: 'red', marginBottom: '10px', width: '100%' }} accept=".pdf,.docx,.jpg,.zip" onChange={(e) => this.onAttachmentChange(e, i)} />
        </Col>
        <Col xs={3} style={{ paddingTop: '5px', paddingBottom: '5px', float: 'right' }}>
          <Button
            className="btn btn-danger"
            onClick={() => this.removeAttachment(i)}
          >
            Usuń
          </Button>
        </Col>
        </Row>,
      )
    )
  }

  render() {
    const formats = this.state.fileFormats.join(', ');

    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }
    return (
      <div style={{ fontSize: `${this.props.fontSize}rem`, clear: 'both' }}>
        <div className="col-mobile" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          <div className={'grayPanel'} style={this.state.style}>
            <div className="basePanelHeading" style={this.state.style}>Załączniki</div>
            <div className="panel-body grayPanelBody">
              {this.props.additionalText && <p><b>{this.props.additionalText}</b></p>}
              <Button
                className="btn btn-success"
                style={{ btnStyle }}
                onClick={() => this.addAttachment()}
              >
                  Dodaj załącznik
              </Button>
              <p><br />Wymagane formaty załączników: <b>{formats}</b>.</p>
              <p>Maksymalny łączny rozmiar załączników: <b>{this.state.maxAttachSize}MB</b>.</p>
              <p>Lista załączników:</p>
              {this.state.attachments.length < 1 ? <p style={{ textAlign: 'center' }}>Aby dodać załącznik, kliknij "Dodaj załącznik"</p> : null}
              {this.state.attachments.length > 0 ?
                <div className="col-lg-12">
                  <Row>
                    <Col xs={7} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px' }}>
                      <p><b>Nazwa:</b></p>
                    </Col>
                    <Col xs={3} style={{ paddingTop: '5px', paddingBottom: '5px', float: 'right' }}>
                      <p><b>Działania:</b></p>
                    </Col>
                  </Row>
                  {isMobile || isTablet? this.renderMobileRow() : this.renderStandardRow()}
                </div> : null }
              <p>Łączny rozmiar załączników: <b>{this.state.total_size}MB</b></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default connect(mapState)(AttachmentsPanel);



// WEBPACK FOOTER //
// src/components/AttachmentsPanel/AttachmentsPanel.js